import { Card, Typography } from '@mui/material';
import { FC } from 'react';
import { ForumItem } from 'src/models';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface Props {
  item: ForumItem;
  onClick: () => void;
}

export const ForumVoting: FC<Props> = ({ item, onClick }) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        p: 2,
        mb: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        '&: hover': {
          backgroundColor: '#f5f5f5',
        },
      }}
    >
      <Typography fontSize={'18px'} fontWeight={500}>
        {item.votingTitle}
      </Typography>
      <ArrowForwardIcon />
    </Card>
  );
};
